import ApiInstance from "@/services/api/api.utils";

export const postLogin = async (payload) => {
  const res = await ApiInstance.post("/auth/users/login", payload);
  return res;
};

export const postFacebookLogin = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/login-facebook",
    payload
  );
  return res;
};

export const postPersonalRegister = async (payload) => {
  const res = await ApiInstance.post("/auth/users/personal/register", payload);
  return res;
};

export const postPersonalFacebookRegister = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/register-facebook",
    payload
  );
  return res;
};

export const postCorporateRegister = async (payload) => {
  const res = await ApiInstance.post("/auth/users/corporate/register", payload);
  return res;
};

export const postVerifyCode = async (payload) => {
  const res = await ApiInstance.post("/auth/users/personal/verify", payload);
  return res;
};

export const postCheckFacebookToken = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/register-facebook/check",
    payload
  );
  return res;
};

export const postCheckKakaoToken = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/register-kakao/check",
    payload
  );
  return res;
};

export const postKakaoRegister = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/register-kakao",
    payload
  );
  return res;
};

export const postLoginKakao = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/login-kakao",
    payload
  );
  return res;
};

export const postCheckNaverToken = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/register-naver/check",
    payload
  );
  return res;
};

export const postNaverRegister = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/register-naver",
    payload
  );
  return res;
};

export const postLoginNaver = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/login-naver",
    payload
  );
  return res;
};

export const postChangePassword = async (payload) => {
  const res = await ApiInstance.post("/auth/users/change-password", payload);
  return res;
};

export const postLoginApple = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/login-apple",
    payload
  );
  return res;
};

export const postLoginGoogle = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/login-google",
    payload
  );
  return res;
};

export const postCancellUser = async (payload) => {
  const res = await ApiInstance.post(
    "/auth/users/personal/cancel-user",
    payload
  );
  return res;
};

export const getUserExists = async (username, phone) => {
  const queryParams = new URLSearchParams();
  if (username) {
    queryParams.append("username", username);
  }
  if (phone) {
    queryParams.append("phone", phone);
  }

  const res = await ApiInstance.get(
    `/auth/users/exists?${queryParams.toString()}`
  );
  return res;
};
